import React from "react";
import { AlertTriangle } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { formatDate } from "@/lib/dateFormat";

const fmt = (n) => Math.round(n * 10) / 10;

export const OverbookingDialog = ({ check, onCancel, onConfirm, t }) => (
  <AlertDialog open={!!check} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent className="w-[calc(100%-2rem)] rounded-lg" data-testid="overbooking-dialog">
      {check && (
        <>
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2">
              <AlertTriangle className="h-5 w-5 text-destructive" /> {t("overbooking_title")}
            </AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-2 text-sm">
                <p>{t("overbooking_intro").replace("{date}", formatDate(check.date))}</p>
                <ul className="space-y-1 font-mono-jb" data-testid="overbooking-figures">
                  <li>{t("overbooking_request")}: {fmt(check.volume)} m³</li>
                  <li>{t("overbooking_total")}: {fmt(check.used)} / {fmt(check.quota)} m³</li>
                  <li className="font-semibold text-destructive">{t("overbooking_over")}: {fmt(check.used - check.quota)} m³</li>
                </ul>
                <p>{t("overbooking_question")}</p>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="overbooking-cancel-btn">{t("cancel")}</AlertDialogCancel>
            <AlertDialogAction
              onClick={onConfirm}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
              data-testid="overbooking-confirm-btn"
            >
              {t("overbooking_confirm")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </>
      )}
    </AlertDialogContent>
  </AlertDialog>
);
